(function () {
  'use strict';

  angular.module('app').component('transportationInventoryList', transportationInventoryList());

  function transportationInventoryList() {
    return {
      bindings: {
        calendarDays: '=',
        inventory: '=',
        onInventorySaved: '&',
      },
      controller: TransportationInventoryListCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/transportation-inventories/transportation-inventory-list/transportation-inventory-list.component.html',
    };
  }

  TransportationInventoryListCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$translate',
    '$filter',
    'AbilityService',
    'moment',
    'TransportationInventoryService',
  ];

  function TransportationInventoryListCtrl(
    config,
    UtilService,
    $translate,
    $filter,
    AbilityService,
    moment,
    TransportationInventoryService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    $translate = $filter('translate');

    vm.permissions = {
      canCreate: AbilityService.can('create_transportationinventory_accountadmin'),
      canUpdate: AbilityService.can('update_transportationinventory_accountadmin'),
      canSaveByDates: AbilityService.can(
        'change_total_by_dates_transportationinventory_accountadmin'
      ),
    };

    vm.dateDisplay = config.DATE_DISPLAY_LARGE;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.todayDateFormat = moment().format('YYYY-MM-DD');

    // Methods
    vm.openTransportationInventoryModal = openTransportationInventoryModal;
    vm.popoverPlacement = popoverPlacement;

    // Open the modal for masive add or update by date range
    function openTransportationInventoryModal(transportation, schedule) {
      // if (!transportation.has_prices){
      //     return;
      // }

      if (vm.permissions.canSaveByDates) {
        var selectedItem = transportation;
        var title = transportation.name;

        var inventory = {
          transportation_id: transportation.id,
          title: title,
          transportation_schedule_id: null,
        };

        if (schedule) {
          // if (!schedule.has_prices){
          //     return;
          // }

          selectedItem = schedule;
          inventory.transportation_schedule_id = schedule.id;
          inventory.title = title + ' - ' + $filter('time')(schedule.departure, vm.hourDisplay);
        }

        var successCallback = function () {
          vm.onInventorySaved({ item: selectedItem });
        };

        TransportationInventoryService.openTransportationInventoryModal(inventory, successCallback);
      }
    }

    // Sets the popover placement (Left or Right)
    function popoverPlacement($index) {
      if (vm.calendarType === 'Month') {
        if ($index < 15) {
          return 'right';
        }
      }

      return 'left';
    }

    vm.popoverAdd = {
      templateUrl: 'template_add.html',
      open: function open(item) {
        // vm.newInventory = {
        //   total_availability: 0,
        // };

        vm.newInventoryTotalAvailability = 0;

        item.popoverAddIsOpen = true;

        vm.selectedItem = item;
        vm.confirmCheckBox = false;
      },
      close: function close(item) {
        item.popoverAddIsOpen = false;
        vm.selectedItem = null;
      },
      save: function save() {
        vm.selectedItem.total_availability = vm.newInventoryTotalAvailability; //vm.newInventory.total_availability;

        saveTransportationInventory();
      },
    };

    // Consider a sidebar modal with bokings created as reference
    vm.popoverUpdate = {
      templateUrl: 'template_update.html',
      open: function open(item) {
        vm.totalAvailabilityCopy = angular.copy(item.total_availability);
        item.popoverUpdateIsOpen = true;

        vm.selectedItem = item;
        vm.confirmCheckBox = false;
      },
      close: function close(item) {
        item.popoverUpdateIsOpen = false;
        vm.selectedItem = null;
      },
      save: function save() {
        vm.selectedItem.total_availability = vm.totalAvailabilityCopy;

        saveTransportationInventory();
      },
    };

    // Save-Update
    function saveTransportationInventory() {
      vm.sendingForm = true;
      TransportationInventoryService.saveTransportationInventory(vm.selectedItem).then(
        (response) => {
          if (response) {
            vm.selectedItem.popoverUpdateIsOpen = false;
            vm.selectedItem = null;

            vm.sendingForm = false;
          }
        }
      );
    }
  }
})();
